document.addEventListener('teeinblue-event-after-cart-added', async () => {
    (async () => {
        try {
            const res = await fetch('/cart.js');
            const cart = await res.json();
            const totalQty = cart.items.reduce((sum, item) => sum + item.quantity, 0);
            document.querySelector('.cart-count-bubble span[aria-hidden="true"]').innerText = totalQty;
        } catch (err) {
            return;
        }
    })();
});